import type { Sale, SaleOnboardingProgress } from '../types'

export function buildFallbackOnboardingProgress(sale: Sale): SaleOnboardingProgress {
 const paymentComplete = sale.status === 'paid'

 const invoicingComplete = Boolean(
 sale.invoices?.some((inv) => inv.status === 'issued' || inv.status === 'paid')
 )

 const preparationComplete =
(sale.operationalStage === 'preparation' &&
  (sale.status === 'in_preparation' ||
  sale.status === 'ready_for_delivery' ||
  sale.status === 'delivered')) ||
  sale.operationalStage === 'delivery' ||
  sale.operationalStage === 'post_receiving' ||
  sale.operationalStage === 'completed'

  return {
  payment: {
  complete: paymentComplete,
  blockers: paymentComplete ? [] : ['payment_not_paid'],
  },
  documentation: {
  complete: false,
  blockers: ['onboarding_api_unavailable'],
  customerDocuments: [],
  contracts: [],
  checklist: [],
  checklistMeta: {
  customerDocumentType: sale.customer?.documentType ?? 'cpf',
  corporatePjComplete: true,
  },
  },
  commissions: {
  complete: Boolean(sale.commissionsConfirmedAt),
  blockers: sale.commissionsConfirmedAt ? [] : ['commissions_not_confirmed'],
  mandatoryRuleIdsExpected: [],
  confirmedAt: sale.commissionsConfirmedAt ?? null,
  },
  invoicing: {
  complete: invoicingComplete,
  blockers: invoicingComplete ? [] : ['no_authorized_fiscal_or_invoice'],
  },
  preparation: {
  complete: preparationComplete,
  operationalStage: sale.operationalStage ?? 'pre_sale',
  saleStatus: sale.status,
  checklistPosVendaOk: true,
  blockers: [],
  },
 canSend: false,
 }
}
